import { Component, HostBinding, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';

@Component({
	selector: 'copo-ecall-off-widget',
	templateUrl: './ecall-off-widget.component.html',
	styleUrl: './ecall-off-widget.component.css',

	imports: [NgIf, TranslateModule, MatButtonModule, RouterLink, MatIconModule, LoadingSpinnerComponent]
})
export class ECallOffWidgetComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;
	@Input() canCallByVolume?: boolean = false;

	isLoading = false;
}
